import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from 'diamond/config/environment';
import { importSync, isDevelopingApp, macroCondition } from '@embroider/macros';
import './font-awesome'; // Add this import statement for Font Awesome setup

const eventlist = {
  mouseover: 'mouseOver',
  mouseout: 'mouseOut',
};

if (macroCondition(isDevelopingApp())) {
  importSync('./deprecation-workflow');
}

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  customEvents = eventlist;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
